export const sleep = (ms: number) => {
  return new Promise((resolve) => setInterval(resolve, ms));
};

/** Batch size used when chunking import rows before upsert. */
export const IMPORT_BATCH_SIZE = 50;

/** Splits an array into chunks of at most `size`. Non-mutating. */
export const chunk = <T>(items: T[], size: number): T[][] => {
  if (size < 1) throw new Error("chunk size must be >= 1");
  const out: T[][] = [];
  for (let i = 0; i < items.length; i += size) {
    out.push(items.slice(i, i + size));
  }
  return out;
};

export const debounce = <T extends (...args: any[]) => void>(
  func: T,
  wait: number
) => {
  let timeout: ReturnType<typeof setTimeout>;
  return (...args: Parameters<T>) => {
    clearTimeout(timeout);
    timeout = setTimeout(() => func(...args), wait);
  };
};

/** Sums a numeric field across the rows, treating non-numbers as 0. */
export const sumBy = <T>(items: T[], field: keyof T): number =>
  items.reduce((total, item) => total + (Number(item[field]) || 0), 0);

/**
 * Whether any row carries a usable number in `field`.
 *
 * A forecast of 0 and "no forecast at all" are different claims, so the surfaces
 * that show a forecast total need to tell them apart before summing: the table
 * renders "-" and the spreadsheet leaves the cell blank rather than asserting a
 * forecast of 0. One predicate so the two cannot disagree.
 */
export const hasNumericValue = <T>(items: T[], field: keyof T): boolean =>
  items.some(
    (item) => item[field] != null && Number.isFinite(Number(item[field]))
  );
